var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:['btn', _vm.sizeClass, _vm.btnClass],attrs:{"to":_vm.href,"target":_vm.target}},[_c('i',{class:['fa', _vm.iconClass]}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }